/* Confirm successful Shopify adds; retain the original add/validation handlers. */
(() => {
  'use strict';
  const dialog = document.querySelector('[data-vna-cart-feedback]');
  if (!dialog || window.VNACartFeedback) return;
  const shade = document.querySelector('[data-vna-feedback-shade]');
  const list = dialog.querySelector('[data-vna-feedback-items]');
  const ja = dialog.dataset.locale.startsWith('ja');
  const cartURL = dialog.dataset.cartUrl || '/cart';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  const closedClass = '.vna-cart-drawer-open,.cart-sidebar-show,.add-to-cart-show';
  const quickSelector = '[data-vna-quick-modal][aria-hidden="false"],[data-vna-showcase-quick-modal][aria-hidden="false"],[data-vna-wishlist-quick-modal][aria-hidden="false"],dialog[open]:not([data-vna-cart-feedback])';
  let origin = null, returnFocus = null, pending = [], shown = [];
  let timer = 0, waitStarted = 0, closeTimer = 0, closing = false, refreshTimer = 0;
  root.classList.add('vna-cart-feedback-enabled');

  const visible = el => el?.isConnected && !el.disabled && el.getClientRects().length && !el.closest('[inert],[hidden],[aria-hidden="true"]') && getComputedStyle(el).visibility !== 'hidden';
  const suppressDrawers = () => {
    if (document.body.matches(closedClass)) document.body.classList.remove('vna-cart-drawer-open','cart-sidebar-show','add-to-cart-show');
  };
  suppressDrawers();
  new MutationObserver(suppressDrawers).observe(document.body,{attributes:true,attributeFilter:['class']});

  function cartLink(el) {
    if (!el) return false;
    if (el.matches('[data-cart-sidebar]')) return true;
    if (!el.matches('a[href]')) return false;
    try {
      const url = new URL(el.href,location.href);
      return url.origin === location.origin && (url.pathname.replace(/\/$/,'') === new URL(cartURL,location.href).pathname.replace(/\/$/,'') || url.pathname === '/cart');
    } catch (_) { return false; }
  }
  window.addEventListener('click', event => {
    const target = event.target.closest?.('[data-cart-sidebar],a[href]');
    if (cartLink(target)) {
      if (target.matches('a') && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || target.target === '_blank')) {
        event.stopImmediatePropagation(); return;
      }
      event.preventDefault(); event.stopImmediatePropagation();
      location.assign(cartURL); return;
    }
    const trigger = event.target.closest?.('[data-vna-quick-open],[data-vna-showcase-quick-open],[data-vna-page-add],[data-vna-wishlist-quick-open]');
    if (trigger) origin = trigger;
    else if (!event.target.closest?.('[data-vna-quick-modal],[data-vna-showcase-quick-modal],dialog')) {
      const button = event.target.closest?.('button,input[type="submit"]');
      if (button?.form && addURL(button.form.action, 'POST')) origin = button;
    }
  },true);

  function close() {
    if (!dialog.open || closing) return;
    closing = true;
    dialog.classList.remove('is-open');
    root.classList.remove('vna-feedback-open');
    const restoreFocus = dialog.contains(document.activeElement);
    closeTimer = setTimeout(() => {
      dialog.close(); closing = false;
      root.classList.remove('vna-feedback-open');
      if (shade) shade.hidden = true;
      if (restoreFocus && visible(returnFocus)) returnFocus.focus({preventScroll:true});
      if (pending.length) schedule();
    },reduced.matches ? 0 : 180);
  }
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{
    if (event.target.closest('[data-vna-feedback-close]')) close();
    else if (event.target === dialog) {
      const r=dialog.getBoundingClientRect();
      if (event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) close();
    }
  });
  window.addEventListener('keydown',event=>{
    if (!dialog.open) return;
    if (event.key === 'Escape') {event.preventDefault();event.stopPropagation();close();return;}
    // Keep all three actions reachable in Safari; Tab can still leave this non-modal card.
    if (event.key === 'Tab' && dialog.contains(document.activeElement)) {
      const nodes=[...dialog.querySelectorAll('button,a[href]')].filter(visible);
      const index=nodes.indexOf(document.activeElement),next=index+(event.shiftKey?-1:1);
      if(index>=0&&next>=0&&next<nodes.length){event.preventDefault();nodes[next].focus({preventScroll:true});}
    }

  });
  window.addEventListener('pagehide',()=>{clearTimeout(timer);clearTimeout(closeTimer);clearTimeout(refreshTimer);dialog.classList.remove('is-open');if(dialog.open)dialog.close();if(shade)shade.hidden=true;root.classList.remove('vna-feedback-open');});

  function money(cents) {
    const currency=window.Shopify?.currency?.active || dialog.dataset.currency || 'JPY';
    try {return new Intl.NumberFormat(ja?'ja-JP':(dialog.dataset.locale||'en'),{style:'currency',currency}).format(cents/100);}
    catch (_) {return (Number(cents)/100).toFixed(2)+' '+currency;}
  }
  function imageURL(value) {
    try {
      if (!value) return '';
      const u=new URL(value,location.href);
      if (!/^https?:$/.test(u.protocol)) return '';
      if (u.hostname.endsWith('.shopify.com') || (u.origin===location.origin && u.pathname.includes('/cdn/shop/'))) u.searchParams.set('width','180');
      return u.href;
    } catch (_) {return '';}
  }
  function node(tag,className,text) {
    const el=document.createElement(tag);if(className)el.className=className;if(text!=null)el.textContent=text;return el;
  }
  function render() {
    list.replaceChildren();
    for (const item of shown) {
      const row=node('article','vna-cart-feedback__item');row.setAttribute('role','listitem');
      const media=node('div','vna-cart-feedback__image');
      if(item.image){const img=new Image();img.alt=item.title;img.src=item.image;img.addEventListener('error',()=>{img.remove();media.textContent='—';},{once:true});media.append(img);}else media.textContent='—';
      const details=node('div','vna-cart-feedback__details');
      details.append(node('h3','vna-cart-feedback__name',item.title));
      const quantity=(ja?'数量 ':'Qty: ')+item.quantity;
      details.append(node('p','vna-cart-feedback__spec',[item.options,quantity].filter(Boolean).join(' · ')));
      const price=node('p','vna-cart-feedback__price',money(item.price));
      price.append(node('small','',ja?' （税込）':' (Tax included)'));
      details.append(price);row.append(media,details);list.append(row);
    }
  }
  function refreshCount() {
    clearTimeout(refreshTimer);
    refreshTimer=setTimeout(async()=>{
      try {
        const path=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/')+'cart.js';
        const response=await fetch(path,{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
        if(!response.ok)return;const cart=await response.json();
        document.querySelectorAll('[data-cart-count],.cart-count-bubble .text').forEach(el=>el.textContent=cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart}}));
      }catch(_){/* A successful add remains successful if the count cannot refresh. */}
    },300);
  }
  function schedule() {clearTimeout(timer);timer=setTimeout(flush,60);}
  function flush() {
    if(!pending.length || closing)return;
    const active=[...document.querySelectorAll(quickSelector)].find(visible);
    const stillClosing=document.querySelector('.is-desktop-quick-closing');
    if(active || stillClosing) {
      if(Date.now()-waitStarted<12000){schedule();return;}
      // The add is confirmed. A slow secondary refresh must not leave its chooser trapped.
      if(active){if(active instanceof HTMLDialogElement)active.close();else active.querySelector('[data-vna-quick-close],[data-vna-showcase-quick-close]')?.click();}
      timer=setTimeout(flush,350);waitStarted=Date.now();return;
    }
    suppressDrawers();
    if(!dialog.open){shown=[];returnFocus=pending[0].trigger;}
    for(const item of pending){
      const existing=shown.find(x=>x.key===item.key&&x.price===item.price);
      if(existing)existing.quantity+=item.quantity;else shown.push(item);
    }
    pending=[];waitStarted=0;render();
    if(!dialog.open){
      if(shade)shade.hidden=false;
      dialog.show();
      requestAnimationFrame(()=>root.classList.add('vna-feedback-open'));
      requestAnimationFrame(()=>dialog.classList.add('is-open'));
      dialog.querySelector('[data-vna-feedback-close]').focus({preventScroll:true});
    }
  }
  const canonical = obj => JSON.stringify(Object.entries(obj||{}).sort(([a],[b])=>a.localeCompare(b)));
  function normalizeRequest(body) {
    if(!body)return[];
    let data=body;
    if(typeof body==='string') {try{data=JSON.parse(body);}catch(_){data=new URLSearchParams(body);}}
    if(data instanceof FormData || data instanceof URLSearchParams){
      const values=Object.fromEntries([...data.entries()].filter(([,v])=>typeof v==='string'));
      const items=[];
      for(const key of Object.keys(values)) {
        const match=key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/);
        if(match){items[Number(match[1])] ||= {};items[Number(match[1])][match[2]]=values[key];}
      }
      data=items.length?{items:items.filter(Boolean)}:values;
    }
    return (Array.isArray(data.items)?data.items:[data]).filter(x=>x?.id).map(x=>({id:String(x.id),quantity:Math.max(1,Number(x.quantity)||1),properties:x.properties||{},plan:String(x.selling_plan||'')}));
  }
  function requestMetadata(input,init) {
    try {
      if(init?.body!=null)return Promise.resolve(normalizeRequest(init.body));
      if(input instanceof Request)return input.clone().text().then(normalizeRequest).catch(()=>[]);
    }catch(_){}
    return Promise.resolve([]);
  }
  function received(payload,requests,trigger) {
    if(!payload || payload.status || payload.errors)return;
    const items=Array.isArray(payload.items)?payload.items:[payload];
    const consumed=new Set();
    for(const item of items){
      if(!item || !(item.variant_id||item.id) || !(item.product_title||item.title))continue;
      const id=String(item.variant_id||item.id),props=canonical(item.properties),plan=String(item.selling_plan_allocation?.selling_plan?.id||'');
      let index=requests.findIndex((x,i)=>!consumed.has(i)&&x.id===id&&canonical(x.properties)===props&&x.plan===plan);
      if(index<0)index=requests.findIndex((x,i)=>!consumed.has(i)&&x.id===id);
      if(index>=0)consumed.add(index);
      const quantity=index>=0?requests[index].quantity:Math.max(1,Number(item.quantity)||1);
      const options=Array.isArray(item.options_with_values)?item.options_with_values.filter(x=>x.value&&x.value!=='Default Title').map(x=>x.name+': '+x.value).join(' / '):item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'';
      const price=Number(item.final_price??item.discounted_price??item.price);
      if(!Number.isFinite(price))continue;
      pending.push({key:id+'|'+props+'|'+plan,title:String(item.product_title||item.title),quantity,options,price,image:imageURL(item.featured_image?.url||item.image||''),trigger});
    }
    if(pending.length){if(!waitStarted)waitStarted=Date.now();schedule();refreshCount();}
  }
  function addURL(input,method) {
    try{const u=new URL(typeof input==='string'||input instanceof URL?input:input.url,location.href);return u.origin===location.origin&&method.toUpperCase()==='POST'&&/\/cart\/add(?:\.js)?\/?$/.test(u.pathname);}catch(_){return false;}
  }
  function source() {
    const active=document.activeElement;
    if (origin && (active===document.body || active===document.documentElement || active?.matches('main') || active?.closest('[data-vna-quick-modal],[data-vna-showcase-quick-modal],dialog'))) return origin;
    return visible(active)?active:origin;
  }
  const seenResponses = new WeakSet();
  function confirmResponse(response, body, trigger = source()) {
    if (!response?.ok || response.bodyUsed || seenResponses.has(response)) return;
    seenResponses.add(response);
    const metadata = Promise.resolve(body).then(value => Array.isArray(value) ? value : normalizeRequest(value));
    try { response.clone().json().then(async payload => received(payload, await metadata, trigger)).catch(() => {}); } catch (_) { /* The original handler retains its response. */ }
  }
  const seenXHR = new WeakSet();
  function confirmXHR(xhr, body, trigger) {
    if(xhr.status<200||xhr.status>=300||seenXHR.has(xhr.__vnaFeedbackRequest || xhr))return;
    seenXHR.add(xhr.__vnaFeedbackRequest || xhr);
    try {received(xhr.responseType==='json'?xhr.response:JSON.parse(xhr.responseText),normalizeRequest(body),trigger);} catch(_){}
  }
  const originalFetch=window.fetch;
  function feedbackFetch(input,init) {
    const add=addURL(input,init?.method||input?.method||'GET');
    const metadata=add?requestMetadata(input,init):null,trigger=add?source():null;
    return originalFetch.apply(this,arguments).then(response=>{
      if(add)confirmResponse(response,metadata,trigger);
      return response;
    });
  }
  feedbackFetch._vnaCartPatched=originalFetch._vnaCartPatched;
  window.fetch=feedbackFetch;
  const xhrOpen=XMLHttpRequest.prototype.open,xhrSend=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(method,url){this.__vnaFeedbackAdd=addURL(String(url),String(method));return xhrOpen.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(body){
    if(this.__vnaFeedbackAdd){const trigger=source();this.addEventListener('loadend',()=>confirmXHR(this,body,trigger),{once:true});}
    return xhrSend.apply(this,arguments);
  };
  // Old product cards may use a custom jQuery transport instead of the current XHR prototype.
  function connectJQuery() {
    if(!window.jQuery || connectJQuery.connected)return;
    connectJQuery.connected=true;
    window.jQuery.ajaxPrefilter((settings, original, jqXHR) => {
      if(!addURL(settings.url,settings.type||'GET'))return;
      const createXHR=settings.xhr;
      if(typeof createXHR==='function')settings.xhr=function(){const xhr=createXHR.apply(this,arguments);xhr.__vnaFeedbackRequest=jqXHR;return xhr;};
    });
    window.jQuery(document).on('ajaxSuccess.vnaCartFeedback',(event,xhr,settings)=>{
      if(addURL(settings.url,settings.type||'GET'))confirmXHR(xhr,settings.data,source());
    });
  }
  connectJQuery();
  document.addEventListener('DOMContentLoaded',connectJQuery,{once:true});
  window.addEventListener('load',connectJQuery,{once:true});
  window.VNACartFeedback={close,confirmResponse};
})();
